import Button from 'src/components/Button';
const PaymentConfirmButton: React.FC<React.PropsWithChildren> = props => {
  const onClick = () => {
    window.close();
  };
  return <Button id='PaymentConfirmButton' data-testid='Payments-ConfirmButton' onClick={onClick} {...props} data-sentry-element="Button" data-sentry-component="PaymentConfirmButton" data-sentry-source-file="index.tsx" />;
};
export default PaymentConfirmButton;